<template>
  <v-container>
    <v-layout>
      <v-flex xs12 text-xs-center>
        Users
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "Users"
};
</script>
